import { Localizer } from "infrastructure/localization/localizer";
import { EvalueringsstatistikPageConstants } from "pages/evalueringsstatistik/components/EvalueringsstatistikPageConstants";

const questionNumberTranslator = (n: number) => {
    return n === EvalueringsstatistikPageConstants.generelCommentsQuestionNumber
        ? Localizer.evalueringPage_generelComments()   
        : n.toString();
}

export default questionNumberTranslator;